/** Session flag: auth succeeded but login page is still finishing validation (e.g. doctor active). */
export const LOGIN_VALIDATION_KEY = "loginValidationInProgress";

export const beginLoginValidation = () => {
  sessionStorage.setItem(LOGIN_VALIDATION_KEY, "1");
  window.dispatchEvent(new Event("loginValidationChanged"));
};

export const endLoginValidation = () => {
  sessionStorage.removeItem(LOGIN_VALIDATION_KEY);
  window.dispatchEvent(new Event("loginValidationChanged"));
};

export const isLoginValidationInProgress = () =>
  sessionStorage.getItem(LOGIN_VALIDATION_KEY) === "1";
